import { render, staticRenderFns } from "./ExpiredDealerManagedBanner.vue?vue&type=template&id=68c8cbf0&scoped=true"
import script from "./ExpiredDealerManagedBanner.vue?vue&type=script&lang=js"
export * from "./ExpiredDealerManagedBanner.vue?vue&type=script&lang=js"
import style0 from "./ExpiredDealerManagedBanner.vue?vue&type=style&index=0&id=68c8cbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c8cbf0",
  null
  
)

export default component.exports